module.exports = __webpack_public_path__ + "img/123.93368972.png";